import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AppConstants {
    public links = {
        'policy': 'https://tiquerapp.com/politica-de-privacidad/',
        'terms_conditions': 'https://tiquerapp.com/terminos-y-condiciones/',
        'register_business': 'https://tiquerapp.com/contactanos/'
    };
}